import { breakOptionsSchema } from 'api/services/zod-schemas/schema';
import { z } from 'zod';

export const bulkShiftActionDataSchema = z.object({
  failure: z.array(
    z.object({
      id: z.string(),
      error: z.string(),
      shiftName: z.string(),
      dateStartEndTime: z.string(),
    })
  ),
  fulfilled: z.array(z.string()),
});

export const getBreakOptionsSchema = z.object({
  breakOptions: z.array(breakOptionsSchema),
});

export type BulkShiftActionData = z.infer<typeof bulkShiftActionDataSchema>;
